module.exports = __webpack_public_path__ + "react/assets/formDisplay/popupWindow.png";